// Todo: Should be in enum
export enum SettingsName {

    OBJ_VEHICLE,
    OBJ_GEOFENCE,
    IS_LIVEMAP_ON,

    isAdmin,

    CredentialUsername,
    AccessToken,
    RefreshToken,
    SessionTimeout,
    LoginFail,
    AccountOptions,
    CredentialOptions_DONOTUSE,
    DriverVehicles_DONTUSE,
    Geofences_DONTUSE,

    SettingsGeneral,
    SettingsGroup,
    ReasonCode_DONTUSE,

    UserOptions,

    LastTokenAssignmentTime,
    AccountId,
    AccountUserMappings,
    AccountSettings
}
